// Pfeil-Navigation für das Cart-Seiten-Karussell (Amazon-Stil, horizontal scrollbar).
function crossSellUpdateArrows(viewport) {
  var track = viewport.querySelector('.cart-cross-sells__track');
  var prev = viewport.querySelector('.cart-cross-sells__arrow--prev');
  var next = viewport.querySelector('.cart-cross-sells__arrow--next');
  if (!track) return;
  var overflow = track.scrollWidth - track.clientWidth > 2;
  [prev, next].forEach(function (a) { if (a) a.style.display = overflow ? '' : 'none'; });
  if (!overflow) return;
  var maxScroll = track.scrollWidth - track.clientWidth - 1;
  if (prev) prev.disabled = track.scrollLeft <= 0;
  if (next) next.disabled = track.scrollLeft >= maxScroll;
}
function crossSellInitCarousels() {
  document.querySelectorAll('.cart-cross-sells__viewport').forEach(function (vp) {
    if (vp.dataset.csInit) return;
    vp.dataset.csInit = '1';
    var track = vp.querySelector('.cart-cross-sells__track');
    if (track) track.addEventListener('scroll', function () { crossSellUpdateArrows(vp); });
    crossSellUpdateArrows(vp);
  });
}
document.addEventListener('DOMContentLoaded', crossSellInitCarousels);
window.addEventListener('load', crossSellInitCarousels);
document.addEventListener('click', function (e) {
  var arrow = e.target.closest('[data-cross-sell-scroll]');
  if (!arrow) return;
  e.preventDefault();
  var viewport = arrow.closest('.cart-cross-sells__viewport');
  if (!viewport) return;
  var track = viewport.querySelector('.cart-cross-sells__track');
  if (!track) return;
  var dir = arrow.getAttribute('data-cross-sell-scroll') === 'prev' ? -1 : 1;
  track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: 'smooth' });
});

// Quick-Add für die „Passende Artikel"-Empfehlungen (Warenkorb-Drawer + Cart-Seite).
// Delegiert auf document, weil der Drawer-Inhalt bei jeder Cart-Änderung neu gerendert wird.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.cross-sell-quick-add');
  if (!btn) return;
  e.preventDefault();
  if (btn.classList.contains('is-loading')) return;
  btn.classList.add('is-loading');

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 })
  })
    .then(function (response) {
      if (!response.ok) throw new Error('add-to-cart failed');
      return response.json();
    })
    .then(function () {
      if (btn.getAttribute('data-context') === 'page') {
        window.location.reload();
        return;
      }
      if (window.theme && theme.Cart && theme.Cart.prototype._onProductAdded) {
        theme.Cart.prototype._onProductAdded();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function () {
      btn.classList.remove('is-loading');
    });
});
